module.exports = __webpack_public_path__ + "static/media/suit_direct.efaa4a9b.jpg";